module.exports = __webpack_public_path__ + "static/media/3.d68a57c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/skin-cancer-surgery-mohs/3.jpg
// module id = 667
// module chunks = 0